import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';

// -- entities
import ProductCategory from 'PMT/entities/menu/ProductCategory';

// -- views

class CategoryItemRow extends Component {

  static propTypes = {
    category: PropTypes.instanceOf(ProductCategory).isRequired,

    isSelected: PropTypes.bool.isRequired,

    onSelect: PropTypes.func,

    onDeselect: PropTypes.func
  };

  defaultProps = {
    onSelect: () => {},
    onDeselect: () => {}
  };

  shouldComponentUpdate(nextProps) {
    return nextProps.isSelected !== this.props.isSelected
      && nextProps.category.id !== this.props.category.id;
  }

  onSelect = () => {
    this.props.onSelect(this.category);
  };

  onDeselect = () => {
    this.props.onDeselect(this.category);
  };

  onClick = () => {
    if (this.isSelected) {
      this.onDeselect();
    } else {
      this.onSelect();
    }
  };

  get category(): ProductCategory {
    return this.props.category;
  }

  get isSelected(): boolean {
    return this.props.isSelected;
  }

  render() {
    return (
      <div
        className="category_item pointer"
        onClick={this.onClick}
      >
        {this.category.name}
      </div>
    );
  }

}

export default CategoryItemRow;
